import React from 'react'
import createSvgIcon from '../createSvgIcon'

export default createSvgIcon(
  <>
    <defs>
      <linearGradient
        id="warningGradient"
        x1="11.8947"
        y1="0"
        x2="11.8947"
        y2="23.1363"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F3DD4D" />
        <stop offset="1" stopColor="#E0BC49" />
      </linearGradient>
      <clipPath id="warningClip">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
    <g clipPath="url(#warningClip)">
      <path
        d="M13.7492 3.2032C12.9238 1.77759 10.8655 1.77759 10.0402 3.2032L0.362187 19.9197C-0.464879 21.3483 0.56596 23.1363 2.21667 23.1363H21.5727C23.2234 23.1363 24.2542 21.3483 23.4272 19.9197L13.7492 3.2032Z"
        fill="url(#warningGradient)"
      />
      <path
        d="M11.8989 17.0478C11.3609 17.0478 10.9247 17.4839 10.9247 18.0219C10.9247 18.5599 11.3609 18.9961 11.8989 18.9961C12.4369 18.9961 12.873 18.5599 12.873 18.0219C12.873 17.4839 12.4369 17.0478 11.8989 17.0478Z"
        fill="white"
      />
      <path
        d="M11.8989 15.749C12.4834 15.749 12.873 15.2814 12.873 14.58L12.873 11.0731C12.873 10.3717 12.4834 9.90408 11.8989 9.90408C11.3144 9.90408 10.9247 10.3717 10.9247 11.0731L10.9247 14.58C10.9247 15.2814 11.3144 15.749 11.8989 15.749Z"
        fill="white"
      />
    </g>
  </>,
  'Warning',
  24
)
